export default __webpack_public_path__ + "static/media/ttr-iphone-mayc-home.054ca5c2.png";